module.exports = __webpack_public_path__ + "img/exclamation-octagon-fill-red.1dce41b8.svg";